/** Font family for code snippets/editors */
export const CODE_FONT_FAMILY = 'Monaco, Menlo, Consolas, "Droid Sans Mono", "Inconsolata", "Courier New", monospace';

/** Default editor width */
export const DEFAULT_WIDTH = 'auto';
/** Default editor height */
export const DEFAULT_HEIGHT = 500;
